export const LAUNCH_STATE = {
  INITIALIZING: 'INITIALIZING',
  VIDEO_LOADED: 'VIDEO_LOADED',
  UI_LOADED: 'UI_LOADED',
  APP_LOADED: 'APP_LOADED',
};

export const FOCUSED_AREA = {
  SCHEDULE_LINES: 'SCHEDULE_LINES',
  CATEGORY_LIST: 'CATEGORY_LIST',
};
